const Staff = {

    // FIELDS
    "staff": "Staff",
    "name": "Staff Name",
    "address": "Staff Address",
    "email": "Staff Email",
    "contact_name": "Staff Contact Name",
    "contact_number": "Contact Number",
    "department": "Department",
    "category": "Category",
    "subcategory": "Subcategory",
    "mobile_access": "Mobile Access",
    "rating": "Staff Rating",
    "service_department": "Service Department",
    "status": "Status",
    "search": "Search",
    "checkbox": "Service Department",


    // PAGE HEADER
    "list_title": "Staff",
    "filter_title": "Staff Filter",

    // TABLE HEADER
    "table_name": "Name",
    "table_email": "Email",
    "table_contact": "Contact",
    "table_department": "Department",

    // ERROR
    "error_name": "Enter Staff Name",
    "error_address": "Enter Staff Address",
    "error_email": "Enter Staff Email",
    "error_contact_name": "Enter Staff Contact Name",
    "error_contact_number": "Enter Contact Number",
    "error_department": "Select Department",
    "error_service_department": "Select Service Department",
    "error_category": "Select Category",
    "error_subcategory": "Select Subcategory",
    "error_mobile_access": "Select Mobile Access",
    "error_rating": "Enter Staff Rating",
    "error_status": "Select Status",

}

export default Staff;

